import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionLaboratoryPersonnels: ITrialInstitutionLaboratoryPersonnelsLoadActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD
        }
    },
    LoadTrialInstitutionLaboratoryPersonnelById: ITrialInstitutionLaboratoryPersonnelLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID,
            id
        }
    },
    LoadTrialInstitutionLaboratoryPersonnelByLaboratoryId: ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdActionCreator = (trialInstitutionLaboratoryId) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,
            trialInstitutionLaboratoryId
        }
    },
    LoadSuccess: ITrialInstitutionLaboratoryPersonnelLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionLaboratoryPersonnelLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionLaboratoryPersonnel: ITrialInstitutionLaboratoryPersonnelSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionLaboratoryPersonnelSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionLaboratoryPersonnelSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionLaboratoryPersonnel: ITrialInstitutionLaboratoryPersonnelCreateActionCreator = (trialInstitutionLaboratoryId) => {

        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE,
            trialInstitutionLaboratoryId
        }
    },
    CreateSuccess: ITrialInstitutionLaboratoryPersonnelCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionLaboratoryPersonnelCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionLaboratoryPersonnel: ITrialInstitutionLaboratoryPersonnelValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionLaboratoryPersonnelValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionLaboratoryPersonnelValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionLaboratoryPersonnelClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionLaboratoryPersonnelFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CLEAR = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CLEAR",

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_FILTER = "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_FILTER";

export interface ITrialInstitutionLaboratoryPersonnelsLoadAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD";
}

export interface ITrialInstitutionLaboratoryPersonnelsLoadActionCreator {
    (): ITrialInstitutionLaboratoryPersonnelsLoadAction;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryPersonnel | Dtos.TrialInstitutionLaboratoryPersonnel[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryPersonnel | Dtos.TrialInstitutionLaboratoryPersonnel[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryPersonnelLoadSuccessAction;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelLoadFailureAction;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadByIdActionCreator {
    (id: number): ITrialInstitutionLaboratoryPersonnelLoadByIdAction;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID";
    trialInstitutionLaboratoryId: number;
}

export interface ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdAction;
}

export interface ITrialInstitutionLaboratoryPersonnelSaveAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE";
    formData: Dtos.TrialInstitutionLaboratoryPersonnel;

}

export interface ITrialInstitutionLaboratoryPersonnelSaveActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryPersonnel
    ): ITrialInstitutionLaboratoryPersonnelSaveAction;
}

export interface ITrialInstitutionLaboratoryPersonnelSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryPersonnelSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryPersonnelSaveSuccessAction;
}

export interface ITrialInstitutionLaboratoryPersonnelSaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryPersonnelSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelSaveFailureAction;
}

export interface ITrialInstitutionLaboratoryPersonnelCreateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE";
    trialInstitutionLaboratoryId: number;
}

export interface ITrialInstitutionLaboratoryPersonnelCreateActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryPersonnelCreateAction
}

export interface ITrialInstitutionLaboratoryPersonnelCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryPersonnel;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialInstitutionLaboratoryPersonnelCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryPersonnel,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionLaboratoryPersonnelCreateSuccessAction;
}

export interface ITrialInstitutionLaboratoryPersonnelCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryPersonnelCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelCreateFailureAction;
}

export interface ITrialInstitutionLaboratoryPersonnelValidateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE";
    formData: Dtos.TrialInstitutionLaboratoryPersonnel;

}

export interface ITrialInstitutionLaboratoryPersonnelValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryPersonnel
    ): ITrialInstitutionLaboratoryPersonnelValidateAction;
}

export interface ITrialInstitutionLaboratoryPersonnelValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryPersonnelValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryPersonnelValidateSuccessAction;
}

export interface ITrialInstitutionLaboratoryPersonnelValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryPersonnelValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelValidateFailureAction;
}

export interface ITrialInstitutionLaboratoryPersonnelClearAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionLaboratoryPersonnelClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionLaboratoryPersonnelClearAction;
}

export interface ITrialInstitutionLaboratoryPersonnelFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionLaboratoryPersonnelFilterAction;
}

export interface ITrialInstitutionLaboratoryPersonnelFilterAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionLaboratoryPersonnelAction =
    ITrialInstitutionLaboratoryPersonnelsLoadAction |
    ITrialInstitutionLaboratoryPersonnelLoadByIdAction |
    ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdAction |
    ITrialInstitutionLaboratoryPersonnelLoadFailureAction |
    ITrialInstitutionLaboratoryPersonnelLoadSuccessAction |
    ITrialInstitutionLaboratoryPersonnelSaveAction |
    ITrialInstitutionLaboratoryPersonnelSaveSuccessAction |
    ITrialInstitutionLaboratoryPersonnelSaveFailureAction |
    ITrialInstitutionLaboratoryPersonnelCreateAction |
    ITrialInstitutionLaboratoryPersonnelCreateSuccessAction |
    ITrialInstitutionLaboratoryPersonnelCreateFailureAction |
    ITrialInstitutionLaboratoryPersonnelValidateAction |
    ITrialInstitutionLaboratoryPersonnelValidateSuccessAction |
    ITrialInstitutionLaboratoryPersonnelValidateFailureAction |
    ITrialInstitutionLaboratoryPersonnelClearAction |
    ITrialInstitutionLaboratoryPersonnelFilterAction;
